// extracted by mini-css-extract-plugin
export default {"menu-items-list":"styles_menu-items-list__Gh23U","dropdownList":"styles_dropdownList__-ju1Y"};